import costarImage from 'assets/images/homepage/costarLogo.png';
import pwcImage from 'assets/images/homepage/pwcLogo.png';
import oxfordImage from 'assets/images/homepage/oxfordLogo.png';
import cbreImage from 'assets/images/homepage/cbreLogo.png';
import jllImage from 'assets/images/homepage/jllLogo.png';
import weworkImage from 'assets/images/homepage/weworkLogo.png';

const costarUrl = 'https://www.costar.com/';
const pwcUrl = 'https://www.pwc.co.uk/';
const oxfordUrl =
  'https://www.sbs.ox.ac.uk/research/centres-and-initiatives/oxford-future-real-estate-initiative';
const cbreUrl = 'https://www.cbre.co.uk/';
const jllUrl = 'https://www.jll.co.uk/ ';
const weworkUrl = 'https://www.wework.com/';

export const LOGOS = [
  { image: costarImage, url: costarUrl },
  { image: pwcImage, url: pwcUrl },
  { image: oxfordImage, url: oxfordUrl },
  { image: cbreImage, url: cbreUrl },
  { image: jllImage, url: jllUrl },
  { image: weworkImage, url: weworkUrl }
];
